import { render, staticRenderFns } from "./TreeSelectField.vue?vue&type=template&id=56587944&scoped=true"
import script from "./TreeSelectField.vue?vue&type=script&lang=js"
export * from "./TreeSelectField.vue?vue&type=script&lang=js"
import style0 from "./TreeSelectField.vue?vue&type=style&index=0&id=56587944&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56587944",
  null
  
)

export default component.exports